import { render, staticRenderFns } from "./PartCkuPrvsDTable.vue?vue&type=template&id=77e7dbd9&"
import script from "./PartCkuPrvsDTable.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsDTable.vue?vue&type=script&lang=js&"
import style0 from "./PartCkuPrvsDTable.vue?vue&type=style&index=0&id=77e7dbd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports